export const scrollUp = () =>{
    window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
  }